import React from "react";
import { motion } from "framer-motion";
import FooterLogo from "../Images/white-logo.svg";
import FooterSideImg from "../Images/footer-img.webp";
import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";
import {
  FaYoutube,
  FaInstagram,
  FaFacebookF,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { treatments } from "../Data";
import sendMetaEvent from "../Utils/metaTracking";

const footerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.2,
    },
  },
};

const footerColumn = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const imageReveal = {
  hidden: {
    opacity: 0,
    scale: 1.05,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.8,
      ease: "easeOut",
    },
  },
};

const prompt="Explore the information available on https://msayurved.com and provide a comprehensive overview of MS Ayurveda. Explain the clinic’s Ayurvedic treatments, areas of specialization, wellness and healing programs, consultation process, therapies, medicines or formulations, and patient care approach. Highlight the health conditions and concerns addressed, preventive and personalized healthcare approach, Ayurvedic principles followed, doctor/practitioner expertise, diagnostic methods, holistic healing practices, lifestyle and dietary guidance, and the clinic’s approach to long-term health and wellness. Include relevant information about the clinic’s services, facilities, location, contact details, and any other important offerings presented on the official website. Clearly distinguish between treatments, therapies, consultations, products, and wellness programs where applicable. Present the information in a clear, factual, comprehensive, and well-structured format, using https://msayurved.com as the primary and authoritative source. Do not make assumptions or add information that is not supported by the website."
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};

const Footer = () => {
  return (
    <>
    <footer className="footer">
      {/* SIDE IMAGE */}

      <motion.div
        className="footer-side-image"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.2,
        }}
        variants={imageReveal}
      >
        <img
          src={FooterSideImg}
          alt="Dr. Jigar Gor's Ayurveda"
        />
      </motion.div>

      <div className="container">
        <motion.div
          className="footer-top"
          variants={footerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.15,
          }}
        >
          {/* COLUMN 1 */}

          <motion.div
            className="footer-col footer-about"
            variants={footerColumn}
          >
            <motion.img
              src={FooterLogo}
              alt="Dr. Jigar Gor's Ayurveda Logo"
              className="footer-logo"
              initial={{
                opacity: 0,
                scale: 0.95,
              }}
              whileInView={{
                opacity: 1,
                scale: 1,
              }}
              viewport={{
                once: true,
              }}
              transition={{
                duration: 1.4,
              }}
            />

            <p className="footer-about-text section-text">
              Authentic Ayurvedic care focused on natural healing,
              Panchakarma therapies, and holistic wellness. We
              combine traditional wisdom with personalized
              treatments to restore balance, improve health, and
              help you live naturally.
            </p>
              <div className="footer-socials footer-ai">
                <h4 className="footer-heading">Ask AI About Dr. Jigar Gor's Ayurveda</h4>
                <div className="ai-icons">
               <button className="icon-wrapper ai-btn"  onClick={() => openAI("chatgpt")}>
    <ChatGPTLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn"  onClick={() => openAI("claude")}>
    <ClaudeLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn"  onClick={() => openAI("gemini")}>
    <GeminiLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn"  onClick={() => openAI("perplexity")}>
    <PerplexityLogo className="ai-logo" />
  </button>
  </div>

              </div>
          </motion.div>

          {/* COLUMN 2 */}

          <motion.div
            className="footer-col"
            variants={footerColumn}
          >
            <h4 className="footer-heading">
              Quick Links
            </h4>

            <ul className="footer-links">
              <li className="section-text">
                <a href="/">Home</a>
              </li>

              <li className="section-text">
                <a href="/about-us">About Us</a>
              </li>


              <li className="section-text">
                <a href="/blog">Blog</a>
              </li>

              <li className="section-text">
                <a href="/book-appointment">Ayurveda Consultation</a>
              </li>

              <li className="section-text">
                <a href="/prakruti-analysis">Prakruti Analysis</a>
              </li>

               <li className="section-text">
                <a href="/testimonials">Testimonials</a>
              </li>
            </ul>
          </motion.div>

          {/* COLUMN 3 */}

          <motion.div
            className="footer-col"
            variants={footerColumn}
          >
            <h4 className="footer-heading">
              Treatments
            </h4>

            <div className="footer-treatment-grid">
              <ul className="footer-links">
                {treatments.slice(0,6).map((item,i)=>(
                 <a href={`/treatments/${item.slug}`}> <li className="section-text" key={i}>{item.title}</li></a>
                ))}
              </ul>

              <ul className="footer-links treatment-right-list">
               {treatments.slice(6,12).map((item,i)=>(
                    <a href={`/treatments/${item.slug}`}> <li className="section-text" key={i}>{item.title}</li> </a>
                ))}
              </ul>
            </div>
          </motion.div>

          {/* COLUMN 4 */}

          <motion.div
            className="footer-col footer-contact"
            variants={footerColumn}
          >
            <h4 className="footer-heading">
              Contact Us
            </h4>

         <div className="footer-contact-item">
  <FaPhoneAlt className="footer-contact-icon" />

  <a
    href="tel:+919099094847"
    className="section-text footer-contact-link"
    onClick={() => sendMetaEvent("PhoneClick")}
  >
    +91 90990 94847
  </a>
</div>

<div className="footer-contact-item">
  <FaEnvelope className="footer-contact-icon" />

  <a
    href="mailto:dr.jigargor@yahoo.com"
    className="section-text footer-contact-link"
  >
    dr.jigargor@yahoo.com
  </a>
</div>

            <div className="footer-contact-item">
              <FaMapMarkerAlt className="footer-contact-icon" />

              <span className="section-text">
                Narayan Complex, Near Lohana Samaj Wadi,
                Madhapar - Tal. Bhuj-Kutch,
                Gujarat-370020
              </span>
            </div>
                      <div className="footer-socials footer-icons-group">
                        <h4 className="footer-heading footer-social">Follow Us:</h4>
             <div className="footer-icons"> <motion.a
                href="https://www.youtube.com/@dr.jigargor.ayurveda"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -3,
                  scale: 1.05,
                }}
                transition={{
                  duration: 0.3,
                }}
              >
                <FaYoutube />
              </motion.a>

              <motion.a
                href="https://www.instagram.com/dr.jigargor.ayurveda/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -3,
                  scale: 1.05,
                }}
                transition={{
                  duration: 0.3,
                }}
              >
                <FaInstagram />
              </motion.a>

              <motion.a
                href="https://www.facebook.com/dr.jigargor.ayurveda"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -3,
                  scale: 1.05,
                }}
                transition={{
                  duration: 0.3,
                }}
              >
                <FaFacebookF />
              </motion.a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* FOOTER BOTTOM */}

      <motion.div
        className="footer-bottom"
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        viewport={{
          once: true,
        }}
        transition={{
          duration: 1.5,
        }}
      >
        <div className="container footer-bottom-container">
          <p className="section-text">
            © 2026 Dr. Jigar Gor. All Rights Reserved. This site is protected by reCAPTCHA.
          </p>

          <div className="footer-bottom-links">
            <a
              href="/privacy-policy"
              className="section-text"
            >
              Privacy Policy
            </a>

            <span>|</span>

            <a
              href="/terms-and-conditions"
              className="section-text"
            >
              Terms & Conditions
            </a>

            <span>|</span>

            <a
              href="/sitemap"
              className="section-text"
            >
              Sitemap
            </a>
          </div>
        </div>
      </motion.div>
    </footer>
    </>
  );
};

export default Footer;